<template>
  <nav :class="$style.root">
    <ul :class="$style.list">
      <li
        v-for="(link, index) in links"
        :class="$style.item"
        :key="index">
        <template v-if="link.path">
          <router-link
            :to="link.path"
            :class="$style.link"
          >{{ link.name }}</router-link>
        </template>
        <template v-else>
          {{ link.name }}
        </template>
      </li>
    </ul>
  </nav>
</template>
<script>
export default {
  name: 'Breadcrumbs',
  props: {
    links: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style lang="scss" module>
@import '../styles/variables';
@import '../styles/mixins';
@import '../styles/helpers';

.root {
  position: absolute;
  left: 0;
  top: 0;
  z-index: $zidx-main;
  width: 100%;
  font-size: 16px;
  line-height: 30px;
  color: $gray-6;

  @include media('<desktop') {
    display: none;
  }
}

.list {
  list-style-type: none;
  display: flex;
}

.item {
  &:not(:last-child)::after {
    content: '/';
    padding: 0 5px;
  }
}

.link {
  color: $red;
  text-decoration: none;

  @include on-event {
    color: $red;
    text-decoration: underline;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Breadcrumbs.vue